function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import React from 'react';
import CardGroup from "./card-group";
import classnames from 'classnames';
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
export function findCardItem() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tempArr = [];
  var tempIndex = -1;
  var childrenArr = [];
  Array.isArray(children) ? childrenArr = children : childrenArr = [children];
  var filterBoolean = childrenArr.filter(function (dom) {
    if (_typeof(dom) === 'object') {
      return dom;
    }
  });
  return filterBoolean.reduce(function (finalDom, current, index) {
    var _current$type;
    if ((current === null || current === void 0 ? void 0 : (_current$type = current.type) === null || _current$type === void 0 ? void 0 : _current$type.displayName) === 'IglooCardItem') {
      tempArr.push(current);
      if (tempIndex === -1) {
        tempIndex = finalDom.length;
        finalDom.push([]);
      }
    } else {
      finalDom.push(current);
      finalDom[tempIndex] = tempArr;
      tempArr = [];
      tempIndex = -1;
    }
    // 处理只有cardItem 的情况
    if (index === filterBoolean.length - 1 && tempIndex !== -1) {
      finalDom[tempIndex] = tempArr;
    }
    return finalDom;
  }, []);
}

//hasCustomizeWrap 存在的情况都是针对 page中出现 cardItem来处理的
export function wrapCardItem() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var hasCustomizeWrap = arguments.length > 1 ? arguments[1] : undefined;
  return children.map(function (item, index) {
    if (Array.isArray(item)) {
      if (!item.length) return null;
      var padding = hasCustomizeWrap ? "24px 24px 32px 24px" : "".concat(index ? 24 : 0, "px 0px 24px 0px");
      return item[0].type.displayName === 'IglooCardItem' ? /*#__PURE__*/_jsx(CardGroup, {
        style: {
          padding: padding
        },
        children: item
      }, index) : item;
    }

    // 对齐样式
    if (item.type.displayName !== 'IglooCard' && hasCustomizeWrap) {
      var className = item.props.className;

      // 因为group的样式也分了两种这里统一处理
      if (item.type.displayName === 'IglooCardGroup') {
        var subHeading = item.props.subHeading;
        return /*#__PURE__*/React.cloneElement(item, _objectSpread(_objectSpread({}, item.props), {}, {
          key: index,
          style: {
            padding: '32px 24px',
            marginBottom: 0
          },
          className: classnames(className, subHeading ? 'igloo-card-detail-top-group-with-head' : 'igloo-card-detail-top-group-no-head')
        }));
      }
      return /*#__PURE__*/React.cloneElement(item, _objectSpread(_objectSpread({}, item.props), {}, {
        key: index,
        className: classnames(className, 'igloo-card-detail-customize-content-wraper')
      }));
    }
    return item;
  });
}
export function DealWithCardItem(children, hasCustomizeWrap) {
  return wrapCardItem(findCardItem(children), hasCustomizeWrap);
}